import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import DatePicker from "react-datepicker";
import ParkingComponent from "../../components/ParkingComponent/ParkingComponent";
import NumberInputWithPopup from "../../components/Inputs/NumberInputWithPopup";
import { FaSearch, FaTimesCircle } from "react-icons/fa";
import { useGetAllParkingSpaceLoByLatAndLangMutation } from "../../redux/services/parkingsApi";
import { useSaveCustomerFavouriteMutation } from "../../redux/services/favouriteApi";
import { getParkingSpaces, setParkings } from "../../redux/slices/parkingSlice";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { Autocomplete } from "@react-google-maps/api";
import LocationPin from "../../components/Maps/LocationPin";
import SpottedParkings from "../../components/Maps/SpottedParkings";
import { toast, Toaster } from "react-hot-toast";
import Loading from "../commons/Loading";
import { Drawer, Modal, Switch } from "@mui/material";
import Filters from "./Filters";
import addDays from "date-fns/addDays";
import Footer from "../../components/Footer/Footer";
import setHours from "date-fns/setHours";
import { IoIosArrowDown } from "react-icons/io";
import { MutableRefObject } from "react";
import {
  getAddressData,
  getSubCategoryData,
  getTripDetails,
  getTypeName,
  setFromLocation,
  setIsLoggedInValue,
  setLocationData,
  setToLocation,
  setTypeName,
} from "../../redux/slices/navSlice";
import { timezones } from "../Home/timezones";
import { selectJwtToken } from "../../redux/slices/authSlice";
import { useSelector } from "react-redux";
import MuiAlert from "../MuiAlert/MuiAlert";
import axios from "axios";
import { useGetParkingTypeDataMutation } from "../../redux/services/parkingTypeApi";
import { useGetAllCitiesMutation } from "../../redux/services/cityApi";
import moment from 'moment';
import { setEnumData } from "../../redux/slices/enumSlice";
import { useGetEnumDataMutation } from "../../redux/services/enumApi";
import MultipleStop from "../../assets/stops.png";
import Staywithyou from "../../assets/Cab.png";
import SightSeeing from "../../assets/Convenient.png";
import Calender from "../../assets/date.svg";
import Location from "../../assets/location.svg";
import FilterIcon from "../../assets/FilterIcon.png";
import ArrowImage from "../../assets/ArrowImage.png";
import clearIcon from "../../assets/Cancel.png";
import downArrow from "../../assets/Down Arrow White@4x.png";
import { CustomizedSteppers } from "../../components/StatusBar/CustomStepLabel";



type Props = {};

const FindParkingSlot = (props: Props) => {
  const placesSearchRefFrom = useRef<HTMLInputElement>(null);
  const placesSearchRefTo = useRef<HTMLInputElement>(null);
  const [getAllCities, { data, isLoading, error }] = useGetAllCitiesMutation();
  const [cities, setCities] = useState<any[]>([]);
  const location: any = useLocation();
  const id = useAppSelector(getSubCategoryData);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const dispatch = useAppDispatch();
  const parkingSpacesData = useAppSelector(getParkingSpaces);
  const addressData = useAppSelector(getAddressData);
  console.log("addressData==>", addressData)
  const [fromcoords, setFromCoords] = useState<null | any>();
  const [toCoords, setToCoords] = useState<null | any>();
  const [currentLocation, setCurrentLocation] = useState<null | any>();
  const [autocompleteToCity, setAutocompleteToCity]: any = useState();
  const [autocompleteFromCity, setAutocompleteFromCity]: any = useState();
  const [parkingSpaces, setParkingSpaces] = useState<null | any>();
  const placesSearchRef = useRef<HTMLInputElement | any>();
  const [getTripTypeData, tripTypeResponse] = useGetParkingTypeDataMutation();

  const [tripTypeData, setTripTypeData] = useState([]);
  const [getAllParkingSpaceLoByLatAndLang, allResponse] =
    useGetAllParkingSpaceLoByLatAndLangMutation();
  const [saveCustomerFavourite, favouriteResponse] =
    useSaveCustomerFavouriteMutation();
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  // const tripData = useAppSelector(getTripDetails);
  const tripData: any = JSON.parse(localStorage.getItem("tripDetails") || "{}");
  console.log("tripData==>", tripData)
  const [startDate, setStartDate] = useState<Date | null>(
    tripData?.checkIn ? new Date(tripData?.checkIn) : null
  );
  const [endDate, setEndDate] = useState<Date | null>(
    tripData?.checkOut ? new Date(tripData?.checkOut) : null
  );
  const [tripType, setTripType]: any = useState(
    tripData?.TripType ? tripData?.TripType : {}
  );
  const [packageType, setPackageType] = useState([]);
  const [mapKey, setMapKey] = useState([]);
  const [googleApiKey, setGoogleApiKey] = useState<string>('');
  const [isToggel, setIsToggel] = useState(false);
  const [inputFromAddress, setInputFromAddress] = useState("") as any;
  console.log("inputFromAddress==>", inputFromAddress)

  const [inputToAddress, setInputToAddress] = useState("") as any;
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [rowParPage, setRowParPage] = useState(5);
  const [favorateData, setFevorateData] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState() as any;
  const [locationData, setLocationDatas] = useState() as any;
  const [isFromCityUnavailable, setIsFromCityUnavailable] = useState(false);
  const [isToCityUnavailable, setIsToCityUnavailable] = useState(false);
  const [searchCity, setSearchCity] = useState<string>("");
  const [hrFilter, setHrFilter] = useState([
    { id: 0, name: "Hourly", isActive: true, value: "H" },
    { id: 1, name: "Daily", isActive: false, value: "D" },
  ]) as any;
  const [selectedTZOptions, setSelectedTZOptions] = useState<null | any>(
    tripData?.selectedTZOptions ? tripData?.selectedTZOptions : null
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPackageTypeDropdownOpen, setIsPackageTypeDropdownOpen] = useState(false);
  const [displays, setDisplays] = useState(false);

  const getTypeNameValue = useAppSelector(getTypeName);

  const getIsLoggedIn = () => {
    let isLoggedIn: any = localStorage.getItem("isLoggedIn");
    isLoggedIn = JSON.parse(isLoggedIn);
    setIsLoggedIn(isLoggedIn);
  };

  const [selectedPackage, setSelectedPackage]: any = useState(
    tripData?.packageType ? tripData?.packageType : {}
  );
  useEffect(() => {
    getEnumData({});
  }, []);

  useEffect(() => {
    if (enumResponse?.data) {
      const packageTypes = enumResponse.data["PACKAGE_TYPE"] || [];
      const mapKeys = enumResponse.data["MAP_KEY"] || [];
      setPackageType(packageTypes);
      setMapKey(mapKeys);
    }
  }, [enumResponse]);

  useEffect(() => {
    mapKey.map((map: any) => {
      if (map.type === 'MAP_KEY') {
        setGoogleApiKey(map.displayValue);
      }
    });
  }, []);

  const packageTypeValue = tripData?.packageType || "";

  const [duration, distance] = packageTypeValue.match(/\d+/g) || [0, 0]

  const selectedNewPackage: string = String(selectedPackage || "");

  const [selectedDuration, selectedDistance] = selectedNewPackage.match(/\d+/g) || [0, 0];
  const FilterParking = (event: any) => {
    dispatch(setTypeName(event.typeName))
    setTripType(event);


    getAllParkingSpaceLoByLatAndLang({
      payload: {
        offset: 5,
        page: 0,
        fromLat: tripData?.cityFlag ? 0 : fromcoords.lat,
        fromLng: tripData?.cityFlag ? 0 : fromcoords.lng,
        toLat: tripData?.cityFlag ? 0 : toCoords.lat,
        toLng: tripData?.cityFlag ? 0 : toCoords.lng,
        customerId: isLoggedIn ? currentUser.customerId : 0,
        checkInTime: tripData?.checkIn,
        checkOutTime: tripType?.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
          ? null
          : tripType.typeName === "OutStation Round Trip"
            ? endDate
            : tripType.typeName === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(
                    (
                      typeof selectedPackage === "string"
                        ? selectedPackage.match(/^(\d+)\s*hrs/)?.[1]
                        : typeof tripData?.packageType === "string"
                          ? tripData?.packageType.match(/^(\d+)\s*hrs/)?.[1]
                          : "2"
                    ) || "2",
                    10
                  ),
                  "hours"
                )
                .toDate()
              : tripData.checkOut,
        orderBy: "asc",
        columnName: "id",
        parkingTypeId: [event?.id],
        seatingCapacity: tripData?.peopleCount,
        luggageCapacity: tripData?.luggageCount,
        packageType: tripData.packageType,
        distance: (tripType?.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType?.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      },
    });
  };

  useEffect(() => {
    getIsLoggedIn();
  }, [isLoggedIn]);

  useEffect(() => {
    if (tripTypeResponse.isSuccess) {
      setTripTypeData(tripTypeResponse.data.data)
    }
  }, [tripTypeResponse.isSuccess])

  useEffect(() => {
    getTripTypeData({
      payload: {
        offset: rowParPage,
        pageNumber: page,
        sortOrder: order,
        status: true,
      },
    });
  }, [getTripTypeData]);


  useEffect(() => {
    setFromCoords({
      lat: tripData?.address != undefined ? tripData?.address?.fromLocation?.lat : 0,
      lng: tripData?.address != undefined ? tripData?.address?.fromLocation?.lng : 0,
    });

    setInputFromAddress(fromcoords)

    setToCoords({
      lat: tripData?.address != undefined ? tripData?.address?.toLocation?.lat : 0,
      lng: tripData?.address != undefined ? tripData?.address?.toLocation?.lng : 0,
    })

    setInputToAddress(toCoords);
  }, [addressData]);

  useEffect(() => {
    // navigator.geolocation.getCurrentPosition(function (position) {
    //   const currentCoords = {
    //     lat:
    //       location?.state.address != undefined
    //         ? location?.state?.address?.lat
    //         : position?.coords?.latitude,
    //     lng:
    //       location?.state.address != undefined
    //         ? location?.state?.address?.lng
    //         : position?.coords?.longitude,
    //   };
    //   setFromCoords(currentCoords);
    //   setCurrentLocation(currentCoords);
    // });
    // setLocationDatas(addressData && addressData ? addressData : "");
    setInputFromAddress(
      tripData?.address
        ? tripData?.address?.fromLocation
        : addressData && addressData
          ? addressData?.fromLocation
          : ""
    );
    setInputToAddress(
      tripData?.address
        ? tripData?.address?.toLocation
        : addressData && addressData
          ? addressData?.toLocation
          : ""
    );
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsToggel(event.target.checked);
  };

  useEffect(() => {
    localStorage.setItem(
      "lat",
      JSON.stringify(tripData?.cityFlag ? 0 : fromcoords?.lat)
    );
    localStorage.setItem(
      "lng",
      JSON.stringify(tripData?.cityFlag ? 0 : fromcoords?.lng)
    );

    if (
      fromcoords &&
      tripData?.parkingTypeId === undefined &&
      tripData?.cityIds === undefined
    ) {
      let payload: any = {
        offset: 5,
        page: 0,
        fromLat: tripData?.cityFlag ? 0 : fromcoords?.lat,
        fromLng: tripData?.cityFlag ? 0 : fromcoords?.lng,
        toLat: tripData?.cityFlag ? 0 : toCoords?.lat,
        toLng: tripData?.cityFlag ? 0 : toCoords?.lng,
        customerId: isLoggedIn ? currentUser.customerId : 0,
        checkInTime: tripData.checkIn,
        checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
          ? null
          : tripType.typeName === "OutStation Round Trip"
            ? endDate
            : tripType.typeName === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(
                    (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                    10
                  ),
                  "hours"
                )
                .toDate()
              : tripData.checkOut,
        orderBy: "asc",
        columnName: "id",
        parkingTypeId: [tripType?.id],
        seatingCapacity: tripData.peopleCount,
        luggageCapacity: tripData.luggageCount,
        packageType: selectedPackage ? selectedPackage : tripData.packageType,
        distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      };

      getAllParkingSpaceLoByLatAndLang({
        payload: payload,
      });
    }
    if (fromcoords && tripType?.id) {
      let payload: any = {
        offset: 5,
        page: 0,
        fromLat: tripData?.cityFlag ? 0 : fromcoords?.lat,
        fromLng: tripData?.cityFlag ? 0 : fromcoords?.lng,
        toLat: tripData?.cityFlag ? 0 : toCoords?.lat,
        toLng: tripData?.cityFlag ? 0 : toCoords?.lng,
        customerId: isLoggedIn ? currentUser.customerId : 0,
        checkInTime: startDate ? startDate : tripData?.checkIn,
        checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
          ? null
          : tripType.typeName === "OutStation Round Trip"
            ? endDate
            : tripType.typeName === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(
                    (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                    10
                  ),
                  "hours"
                )
                .toDate()
              : tripData.checkOut,
        orderBy: "asc",
        columnName: "id",
        parkingTypeId: [tripType?.id],
        seatingCapacity: tripData.peopleCount,
        luggageCapacity: tripData.luggageCount,
        packageType: tripData.packageType,
        distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      };
      getAllParkingSpaceLoByLatAndLang({
        payload: payload,
      });
    }
    if (fromcoords && tripData?.cityIds) {
      let payload: any = {
        offset: 5,
        page: 0,
        cityName: [
          tripData?.cityName
            ? tripData?.cityName
            : inputFromAddress?.formatted_address,
        ],
        cityIds: [
          tripData?.cityIds
            ? tripData?.cityIds
            : inputFromAddress?.formatted_address,
        ],
        customerId: isLoggedIn ? currentUser.customerId : 0,
        orderBy: "asc",
        columnName: "id",
        checkInTime: startDate ? startDate : tripData?.checkIn,
        checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
          ? null
          : tripType.typeName === "OutStation Round Trip"
            ? endDate
            : tripType.typeName === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(
                    (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                    10
                  ),
                  "hours"
                )
                .toDate()
              : tripData.checkOut,
        parkingTypeId: [tripType?.id],
        seatingCapacity: tripData.peopleCount,
        luggageCapacity: tripData.luggageCount,
        distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      };
      getAllParkingSpaceLoByLatAndLang({
        payload: payload,
      });
    }
  }, [fromcoords, tripData?.cityIds, tripData?.parkingTypeId]);

  useEffect(() => {
    if (allResponse.isSuccess) {
      dispatch(setParkings(allResponse.data));
      dispatch(setIsLoggedInValue(isLoggedIn));
      if (tripData?.address) {
      }
    } else if (allResponse.isError) {
    }
  }, [allResponse.isSuccess, allResponse.isError]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  useEffect(() => {
    if (favouriteResponse.isSuccess) {

      if (
        fromcoords &&
        tripData?.parkingTypeId === undefined &&
        tripData?.cityIds === undefined
      ) {
        let payload: any = {
          offset: 5,
          page: 0,
          fromLat: tripData?.cityFlag ? 0 : fromcoords.lat,
          fromLng: tripData?.cityFlag ? 0 : fromcoords.lng,
          toLat: tripData?.cityFlag ? 0 : toCoords.lat,
          toLng: tripData?.cityFlag ? 0 : toCoords.lng,
          customerId: isLoggedIn ? currentUser.customerId : 0,
          checkInTime: startDate ? startDate : tripData?.checkIn,
          checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
            ? null
            : tripType.typeName === "OutStation Round Trip"
              ? endDate
              : tripType.typeName === "Hourly Rental" && startDate
                ? moment(startDate)
                  .add(
                    parseInt(
                      (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                      10
                    ),
                    "hours"
                  )
                  .toDate()
                : tripData.checkOut,
          orderBy: "asc",
          columnName: "id",
          parkingTypeId: [tripType?.id],
          seatingCapacity: tripData.peopleCount,
          packageType: tripData.packageType,
          distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
          duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
        };
        getAllParkingSpaceLoByLatAndLang({
          payload: payload,
        });
      }
      if (fromcoords && tripData?.parkingTypeId) {
        let payload: any = {
          offset: 5,
          page: 0,
          fromLat: tripData?.cityFlag ? 0 : fromcoords.lat,
          fromLng: tripData?.cityFlag ? 0 : fromcoords.lng,
          toLat: tripData?.cityFlag ? 0 : toCoords.lat,
          toLng: tripData?.cityFlag ? 0 : toCoords.lng,
          checkInTime: startDate ? startDate : tripData?.checkIn,
          checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
            ? null
            : tripType.typeName === "OutStation Round Trip"
              ? endDate
              : tripType.typeName === "Hourly Rental" && startDate
                ? moment(startDate)
                  .add(
                    parseInt(
                      (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                      10
                    ),
                    "hours"
                  )
                  .toDate()
                : tripData.checkOut,
          parkingTypeId: [tripType?.id],
          customerId: isLoggedIn ? currentUser.customerId : 0,
          orderBy: "asc",
          columnName: "id",
          bookingType: favorateData ? favorateData : "H",
          seatingCapacity: tripData.peopleCount,
          packageType: tripData.packageType,
          distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
          duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
        };
        getAllParkingSpaceLoByLatAndLang({
          payload: payload,
        });
      }
      if (fromcoords && tripData?.cityIds) {
        let payload: any = {
          offset: 5,
          page: 0,
          cityName: [
            tripData?.cityName
              ? tripData?.cityName
              : inputFromAddress?.formatted_address,
          ],
          cityIds: [
            tripData?.cityIds
              ? tripData?.cityIds
              : inputFromAddress?.formatted_address,
          ],
          customerId: isLoggedIn ? currentUser.customerId : 0,
          orderBy: "asc",
          columnName: "id",
          checkInTime: startDate ? startDate : tripData?.checkIn,
          checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
            ? null
            : tripType.typeName === "OutStation Round Trip"
              ? endDate
              : tripType.typeName === "Hourly Rental" && startDate
                ? moment(startDate)
                  .add(
                    parseInt(
                      (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                      10
                    ),
                    "hours"
                  )
                  .toDate()
                : tripData.checkOut,
          bookingType: favorateData ? favorateData : "H",
          seatingCapacity: tripData.peopleCount,
          packageType: tripData.packageType,
          distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
          duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
        };
        getAllParkingSpaceLoByLatAndLang({
          payload: payload,
        });
      }
    }
  }, [favouriteResponse.isSuccess]);

  useEffect(() => {
    if (parkingSpacesData) {
      setParkingSpaces(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  useEffect(() => {
    if (searchCity && typeof searchCity === "string" && searchCity.trim() !== "") {
      getAllCities({
        token: token,
        payload: {
          offset: 5,
          page: 0,
          status: true,
          searchValue: searchCity,
        },
      }).then((response) => {
        if ("data" in response) {
          setCities(response.data.data || []);

          const cityExists = response.data.data.some((cityItem: any) =>
            cityItem.name?.toLowerCase() === searchCity.toLowerCase()
          );

          setIsFromCityUnavailable(!cityExists);
          if (!cityExists) {
            toast.error(`We are currently not available in ${searchCity}.`);
          }
        } else if ("error" in response) {
          console.error("Failed to fetch cities:", response.error);
        }
      });
    }
  }, [searchCity]);

  const onLoadFromCity = (autoC: any) => {
    setAutocompleteFromCity(autoC);
  };

  const onPlaceChangedFromCity = () => {
    const place = autocompleteFromCity.getPlace();

    if (!place.geometry) {
      console.error("Autocomplete place data is incomplete.");
      return;
    }

    const locationDetail = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      formatted_address: place.formatted_address || "",
      postalcode: "",
      country: "",
      state: "",
      city: "",
      locality: "",
      sublocality: "",
      route: "",
      street: "",
    };

    place.address_components.forEach((component: any) => {
      if (component.types.includes("postal_code")) {
        locationDetail.postalcode = component.long_name;
      }
      if (component.types.includes("country")) {
        locationDetail.country = component.long_name;
      }
      if (component.types.includes("administrative_area_level_1")) {
        locationDetail.state = component.long_name;
      }
      if (component.types.includes("administrative_area_level_2")) {
        locationDetail.city = component.long_name;
      }
      if (component.types.includes("locality")) {
        locationDetail.locality = component.long_name;
      }
      if (component.types.includes("sublocality")) {
        locationDetail.sublocality = component.long_name;
      }
      if (component.types.includes("route")) {
        locationDetail.route = component.long_name;
      }
      if (component.types.includes("street_number")) {
        locationDetail.street = component.long_name;
      }
    });

    const city = locationDetail.locality || locationDetail.city;
    if (typeof city === "string") {
      setSearchCity(city);
    }

    // Get the current trip details from localStorage
    const tripData = JSON.parse(localStorage.getItem("tripDetails") || "{}");

    // Ensure tripData.address exists before modifying it
    if (!tripData.address) {
      tripData.address = {};
    }

    // Update only the fromLocation inside address
    tripData.address.fromLocation = locationDetail;

    // Save updated data back to localStorage
    localStorage.setItem("tripDetails", JSON.stringify(tripData));

    // Update state and dispatch new location
    dispatch(setFromLocation(locationDetail));
    let payload = {
      fromLocation: locationDetail,
      toLocation: tripData?.toLocation,
    }
    dispatch(setLocationData(payload))
    setFromCoords({
      lat: locationDetail.lat,
      lng: locationDetail.lng,
    });

    setInputFromAddress(locationDetail.formatted_address);
  };

  const onLoadToCity = (autoC: any) => {
    setAutocompleteToCity(autoC);
  };

  const onPlaceChangedToCity = () => {
    const place = autocompleteToCity.getPlace();

    if (!place.geometry) {
      console.error("Autocomplete place data is incomplete.");
      return;
    }

    const locationDetail = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      formatted_address: place.formatted_address || "",
      postalcode: "",
      country: "",
      state: "",
      city: "",
      locality: "",
      sublocality: "",
      route: "",
      street: "",
    };

    place.address_components.forEach((component: any) => {
      if (component.types.includes("postal_code")) {
        locationDetail.postalcode = component.long_name;
      }
      if (component.types.includes("country")) {
        locationDetail.country = component.long_name;
      }
      if (component.types.includes("administrative_area_level_1")) {
        locationDetail.state = component.long_name;
      }
      if (component.types.includes("administrative_area_level_2")) {
        locationDetail.city = component.long_name;
      }
      if (component.types.includes("locality")) {
        locationDetail.locality = component.long_name;
      }
      if (component.types.includes("sublocality")) {
        locationDetail.sublocality = component.long_name;
      }
      if (component.types.includes("route")) {
        locationDetail.route = component.long_name;
      }
      if (component.types.includes("street_number")) {
        locationDetail.street = component.long_name;
      }
    });

    const city = locationDetail.locality || locationDetail.city;

    if (city) {
      const cityExists = cities.some((cityItem: any) =>
        cityItem.name.toLowerCase() === city.toLowerCase()
      );

      {/** 
        if (!cityExists) {
            setIsToCityUnavailable(true);
            toast.error(`We are currently not available in ${city}.`);
            return;
        } else {
            setIsToCityUnavailable(false);
        } 
        */}
    }

    // Get the current trip details from localStorage
    const tripData = JSON.parse(localStorage.getItem("tripDetails") || "{}");

    // Ensure tripData.address exists before modifying it
    if (!tripData.address) {
      tripData.address = {};
    }

    // Update only the toLocation inside address
    tripData.address.toLocation = locationDetail;

    // Save updated data back to localStorage
    localStorage.setItem("tripDetails", JSON.stringify(tripData));

    // Dispatch updated location
    dispatch(setToLocation(locationDetail));
    let payload = {
      fromLocation: tripData?.fromLocation,
      toLocation: locationDetail,
    }
    dispatch(setLocationData(payload))
    setToCoords({
      lat: locationDetail.lat,
      lng: locationDetail.lng,
    });

    setInputToAddress(locationDetail.formatted_address);
  };



  const clearSearchResults = (field: 'from' | 'to') => {
    if (field === 'from' && placesSearchRefFrom.current) {
      setInputFromAddress("");
      placesSearchRefFrom.current.value = "";
      dispatch(setFromLocation(null));
    }
    if (field === 'to' && placesSearchRefTo.current) {
      setInputToAddress("");
      placesSearchRefTo.current.value = "";
    }
  };

  const toggleFavourites = (parking: any) => {
    let payload = {
      parkingLocationId: parking.id,
      customerId: currentUser?.customerId,
      status: !parking.isFavourite,
    };
    saveCustomerFavourite({ token: token, payload: payload });
  };

  useEffect(() => {
    if (favouriteResponse.isSuccess) {
      const message = favouriteResponse.data.status
        ? "Vehicle added to favorites"
        : "Vehicle removed from favorites";
      setStatusCode({ type: "success", code: message });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    } else if (favouriteResponse.isError) {
      setStatusCode({
        type: "error",
        code: "CONSENT_FORM_ERROR",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [favouriteResponse.isSuccess, favouriteResponse.isError]);



  const filterPassedTime = (time: any) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };
  const parkingComponent = () => {

    if (
      fromcoords &&
      tripData?.parkingTypeId === undefined &&
      tripData?.cityIds === undefined
    ) {
      let payload: any = {
        offset: 5,
        page: 0,
        fromLat: tripData?.cityFlag ? 0 : fromcoords.lat,
        fromLng: tripData?.cityFlag ? 0 : fromcoords.lng,
        toLat: tripData?.cityFlag ? 0 : toCoords.lat,
        toLng: tripData?.cityFlag ? 0 : toCoords.lng,
        customerId: isLoggedIn ? currentUser.customerId : 0,
        checkInTime: startDate ? startDate : tripData?.checkIn,
        checkOutTime:
          tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
            ? null
            : tripType.typeName === "OutStation Round Trip"
              ? endDate
              : tripType.typeName === "Hourly Rental" && startDate
                ? moment(startDate)
                  .add(
                    parseInt(
                      (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                      10
                    ),
                    "hours"
                  )
                  .toDate()
                : tripData.checkOut,
        orderBy: "asc",
        columnName: "id",
        parkingTypeId: [tripType?.id],
        seatingCapacity: peopleCount ? peopleCount : tripData.peopleCount,
        luggageCapacity: luggageCount ? luggageCount : tripData.luggageCount,
        packageType: selectedPackage ? selectedPackage : tripData.packageType,
        distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      };
      getAllParkingSpaceLoByLatAndLang({
        payload: payload,
      });
    }
    if (fromcoords && tripData?.parkingTypeId) {
      let payload: any = {
        offset: 5,
        page: 0,
        fromLat: tripData?.cityFlag ? 0 : fromcoords.lat,
        fromLng: tripData?.cityFlag ? 0 : fromcoords.lng,
        toLat: tripData?.cityFlag ? 0 : toCoords.lat,
        toLng: tripData?.cityFlag ? 0 : toCoords.lng,
        parkingTypeId: [tripType?.id],
        customerId: isLoggedIn ? currentUser.customerId : 0,
        checkInTime: startDate ? startDate : tripData?.checkIn,
        checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
          ? null
          : tripType.typeName === "OutStation Round Trip"
            ? endDate
            : tripType.typeName === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(
                    (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                    10
                  ),
                  "hours"
                )
                .toDate()
              : tripData.checkOut,
        orderBy: "asc",
        columnName: "id",
        seatingCapacity: tripData.peopleCount,
        distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      };
      getAllParkingSpaceLoByLatAndLang({
        payload: payload,
      });
    }
    if (fromcoords && tripData?.cityIds) {
      let payload: any = {
        offset: 5,
        page: 0,
        cityName: [
          tripData?.cityName
            ? tripData?.cityName
            : inputFromAddress?.formatted_address,
        ],
        cityIds: [tripData?.cityIds],
        customerId: isLoggedIn ? currentUser.customerId : 0,
        orderBy: "asc",
        columnName: "id",
        checkInTime: startDate ? startDate : tripData?.checkIn,
        checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
          ? null
          : tripType.typeName === "OutStation Round Trip"
            ? endDate
            : tripType.typeName === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(
                    (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                    10
                  ),
                  "hours"
                )
                .toDate()
              : tripData.checkOut,
        parkingTypeId: [tripType?.id],
        seatingCapacity: tripData.peopleCount,
        packageType: selectedPackage ? selectedPackage : tripData.packageType,
        distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      };
      getAllParkingSpaceLoByLatAndLang({
        payload: payload,
      });
    }
  };

  const handleFilter = (parkingResponse: any) => {
    setParkingSpaces(parkingResponse.data);
  };

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  // useEffect(() => {
  //   function handleWindowResize() {
  //     setWindowSize(getWindowSize());
  //   }

  //   window.addEventListener("resize", handleWindowResize);

  //   return () => {
  //     window.removeEventListener("resize", handleWindowResize);
  //   };
  // }, []);

  function selectedStDate(item: any) { }

  useEffect(() => {
    const selectedTimeZone = timezones.filter(
      (item) => item.value === Intl.DateTimeFormat().resolvedOptions().timeZone
    );

    setSelectedTZOptions(selectedTimeZone);
  }, []);

  const [peopleCount, setPeopleCount] = useState<number>(
    tripData?.peopleCount ? tripData?.peopleCount : 1
  ); // Initialize peopleCount
  const [luggageCount, setLuggageCount] = useState<number>(
    tripData?.luggageCount ? tripData?.luggageCount : 0
  ); // Initialize luggageCount

  const handlePeopleCountChange = (newCount: number) => {
    setPeopleCount(newCount);
  };

  const handleLuggageCountChange = (newCount: number) => {
    setLuggageCount(newCount);
  };

  const [errors, setErrors] = useState<string[]>([]);

  const validateFields = () => {
    const validationErrors: string[] = [];

    if (!inputFromAddress) {
      validationErrors.push("From City is required.");
    } else if (isFromCityUnavailable === true) {
      validationErrors.push(`We are unavailable in ${searchCity}.`);
    }
    if (tripType?.typeName !== "Hourly Rental") {
      if (!inputToAddress) {
        validationErrors.push("To City is required.");
      }
    }

    if (!startDate) validationErrors.push("Checkin date is required.");

    if (tripType?.typeName === "OutStation Round Trip") {
      if (!endDate) validationErrors.push("Checkout date is required.");
      if (endDate && startDate && endDate <= startDate) {
        validationErrors.push("Checkout date must be after Checkin date.");
      }
    }

    if (tripType?.typeName === "Hourly Rental") {
      if (!selectedPackage) {
        validationErrors.push("Package Type is required.");
      }
    }

    setErrors(validationErrors);

    return validationErrors.length === 0;
  };

  const handleSearchClick = () => {
    if (validateFields()) {
      parkingComponent();
    }
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = windowSize.width < 1024;


  return (
    <div className="flex flex-col w-full ">
      <div className="flex-grow md:px-10 px-2">
        <CustomizedSteppers activeStep={0} />
        <div className=" w-full hidden lg:block  flex flex-col">
          <Toaster />
          <div className="w-full mt-5 bg-[#F9F4EF] rounded-3xl p-4 ">
            <div className="w-full flex flex-row gap-2">
              {/* Left Section */}
              <div className="w-[90%] flex flex-col">
                {/* Trip Type Selection */}
                <div className="pb-2 flex flex-wrap lg:mt-2 md:flex-row gap-4 justify-start items-center">
                  <div className="flex flex-wrap gap-6">
                    {tripTypeData?.map((option: any) => (
                      <div key={option.id} className="flex flex-col items-center">
                        <label
                          className={`flex items-center gap-2 2xl:py-4 2xl:px-8 xl:py-3 xl:px-6 lg:py-2 lg:px-4 cursor-pointer rounded-full transition-all text-center 
                    xl:w-60 lg:w-50 2xl:w-80
                        ${tripType.typeName === option.typeName
                              ? "bg-[#ED1C24] text-white shadow-md"
                              : "bg-[#58595B] text-white"}
                           `}
                        >
                          <input
                            type="radio"
                            name="options"
                            value={option.typeName}
                            disabled
                            checked={tripType.typeName === option.typeName}
                            onChange={() => FilterParking(option)}
                            className="hidden"
                          />
                          {/* Icon */}
                          <img src={option.imageUrl} className="h-6 w-6" alt="icon" />

                          {/* Trip Type Name */}
                          <span className="text-sm font-semibold">{option.typeName}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Form Section */}
                <div className="flex flex-wrap items-center gap-4 w-full">
                  {/* Pickup Location */}
                  <div className="flex-1">
                    <span className="text-xs font-semibold text-[#58595B] mb-1 block">
                      {tripType?.typeName === "Airport Drop" ? <p>Pickup Address</p> : <p>From City</p>}
                    </span>
                    {!isMobile && (
                      <Autocomplete onLoad={onLoadFromCity} onPlaceChanged={onPlaceChangedFromCity}>
                        <div className="flex items-center bg-[#E2E2E2] gap-3 px-4 py-3 rounded-full">
                          <img src={Location} alt="Location" className="w-4 h-4" />
                          <input
                            type="text"
                            onChange={(e) => setInputFromAddress(e.target.value)}
                            ref={placesSearchRefFrom}
                            placeholder="Search"
                            value={inputFromAddress?.formatted_address}
                            className="w-full bg-transparent text-[#58595B] text-sm placeholder-[#58595B] focus:outline-none"
                          />
                          <img src={clearIcon}
                            onClick={() => {
                              setInputFromAddress(''); // Clear state
                              if (placesSearchRefFrom.current) {
                                placesSearchRefFrom.current.value = ''; // Clear input value
                              }
                              clearSearchResults('from');
                            }}
                            className="cursor-pointer w-3 h-3" />
                        </div>
                      </Autocomplete>
                    )}
                  </div>
                  {/* Pick-up Date & Time */}
                  <div className="flex-1">
                    <span className="text-xs font-semibold text-[#58595B] mb-1 block">PICK-UP DATE & TIME</span>
                    <div className="flex items-center bg-[#E2E2E2] px-4 py-3 gap-3 rounded-full">
                      <img src={Calender} alt="Location" className="w-4 h-4" />
                      <DatePicker
                        selected={startDate}
                        minDate={new Date()}
                        maxDate={addDays(new Date(), 365)}
                        onChange={(date: any) => {
                          setStartDate(new Date(date));
                          setEndDate(new Date(date.getTime() + 2 * 60 * 60 * 1000));
                          selectedStDate(date);
                        }}
                        showTimeSelect
                        timeIntervals={60}
                        dateFormat="dd/MM/yyyy | h:mm aa"
                        placeholderText="DD/MM/YYYY | HH:MM AM/PM"
                        className="w-full bg-transparent text-[#58595B] text-sm focus:outline-none"
                      />
                    </div>
                  </div>
                  {/* Drop-off Location */}
                  {tripType?.typeName !== "Hourly Rental" && (
                    <div className="flex-1">
                      <span className="text-xs font-semibold text-[#58595B] mb-1 block">
                        {tripType?.typeName === "Airport Drop" ? <p>Drop Airport</p> : <p>To City</p>}
                      </span>
                      {!isMobile && (
                        <Autocomplete onLoad={onLoadToCity} onPlaceChanged={onPlaceChangedToCity} options={{
                          types: tripType?.typeName === "Airport Drop" ? ["airport"] : [],
                        }} >
                          <div className="flex items-center bg-[#E2E2E2] gap-3 px-4 py-3 rounded-full">
                            <img src={Location} alt="Location" className="w-4 h-4" />
                            <input
                              onChange={(e) => setInputToAddress(e.target.value)}
                              ref={placesSearchRefTo}
                              placeholder="Search"
                              value={inputToAddress?.formatted_address}
                              className="w-full bg-transparent text-[#58595B] text-sm placeholder-[#58595B] focus:outline-none"
                            />
                            <img src={clearIcon} onClick={() => clearSearchResults('to')} className="cursor-pointer w-3 h-3" />
                          </div>
                        </Autocomplete>
                      )}
                    </div>
                  )}
                  {/* Drop-off Date & Time (Only for Outstation Round Trip) */}
                  {tripType?.typeName === "OutStation Round Trip" && (
                    <div className="flex-1">
                      <span className="text-xs font-semibold gap-3 text-[#58595B] mb-1 block">{tripType?.typeName === "OutStation Round Trip" ? <p>RETURN DATE & TIME</p> : <p>DROP-OFF DATE & TIME</p>}</span>
                      <div className="flex items-center bg-[#E2E2E2] px-4 py-3 gap-3 rounded-full">
                        <img src={Calender} alt="Location" className="w-4 h-4" />
                        <DatePicker
                          selected={endDate}
                          onChange={(date: any) => setEndDate(new Date(date))}
                          showTimeSelect
                          timeIntervals={60}
                          dateFormat="dd/MM/yyyy | h:mm aa"
                          placeholderText="DD/MM/YYYY | HH:MM AM/PM"
                          className="w-full bg-transparent text-[#58595B] text-sm focus:outline-none"
                        />
                      </div>
                    </div>
                  )}
                  {/* Package Type (Only for Hourly Rental) */}
                  {tripType?.typeName === "Hourly Rental" && (
                    <div className="flex-1 relative">
                      {/* Label */}
                      <span className="text-xs font-semibold text-[#58595B] mb-1 block">Package Type</span>
                      {/* Dropdown Button */}
                      <div
                        className="relative flex items-center gap-3 bg-[#E2E2E2] rounded-full px-4 py-3 cursor-pointer"
                        onClick={() => setIsPackageTypeDropdownOpen(!isPackageTypeDropdownOpen)}
                      >
                        {/* Selected Option Text */}
                        <span className="text-[#58595B] text-sm">
                          {selectedPackage || "Select Package"}
                        </span>

                        {/* Dropdown Arrow */}
                        <img src={ArrowImage} alt="Dropdown Arrow" className="w-4 h-4 ml-auto" />
                      </div>

                      {/* Dropdown List */}
                      {isPackageTypeDropdownOpen && (
                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-[90%]  bg-white border border-gray-300 rounded-b-3xl shadow-lg z-10">
                          {packageType.map((option: any, index: any) => (
                            <div
                              key={index}
                              className="flex items-center gap-3 mx-3 px-4 py-2 cursor-pointer mt-2 bg-[#58595B] rounded-3xl text-white font-medium hover:bg-[#ED1C24]"
                              onClick={() => {
                                setSelectedPackage(option.displayValue); // Fix: Set selected package
                                setIsPackageTypeDropdownOpen(false); // Fix: Close dropdown after selection
                              }}
                            >
                              {/* Option Text */}
                              <span>{option.displayValue}</span>
                            </div>
                          ))}

                          {/* Close Dropdown Arrow */}
                          <div
                            className="flex justify-center items-center py-2 cursor-pointer"
                            onClick={() => setIsPackageTypeDropdownOpen(false)} // Fix: Close the dropdown
                          >
                            <img src={ArrowImage} alt="Close Dropdown" className="w-5 h-5 rotate-180" />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {/* Right Section - Search Button */}
              <div className="w-[10%] flex items-center justify-center">
                <div className="relative flex items-center justify-center">
                  {/* Outer Circle */}
                  <div className="relative w-[120px] h-[120px] flex items-center justify-center rounded-full border-[6px] border-[#ED1C24]">
                    {/* Middle Circle (White Border) */}
                    <div className="w-[110px] h-[110px] flex items-center justify-center rounded-full border-[6px] border-white">
                      {/* Inner Circle (Button) */}
                      <button
                        type="submit"
                        onClick={handleSearchClick}
                        className="w-[100px] h-[100px] flex flex-col items-center justify-center rounded-full bg-[#ED1C24] text-white font-semibold text-lg transition-all hover:bg-[#ED1C24]"
                      >
                        <span className="text-md lg:text-lg tracking-widest">ENGINE</span>
                        <span style={{ fontWeight: "bold" }} className="text-md lg:text-lg tracking-widest">START</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full mt-4 gap-2 items-center">
            {/* Why Book With Us Section */}
            <div className="bg-[#D3F4F3] p-3 rounded-3xl w-[90%]">
              <div className="flex flex-col md:flex-row gap-6  items-center">
                {/* Heading */}
                <h4 className="text-lg  text-[#003334] font-semibold md:w-1/4 text-center md:text-left">
                  Why Book with us?
                </h4>
                {/* Features Section */}
                <div className="flex flex-col md:flex-row gap-6 w-full justify-center">
                  {/* Feature 1 - Convenient Sightseeing */}
                  <div className="flex items-center gap-3">
                    <img src={SightSeeing} alt="Sightseeing Icon" className="w-10 h-10" />
                    <div>
                      <h5 className="font-semibold text-sm text-[#003334] ">Convenient sightseeing</h5>
                      <p className="text-xs text-[#003334]">
                        Comfortable cabs for great vacation experiences
                      </p>
                    </div>
                  </div>
                  {/* Feature 2 - Cab Stays With You */}
                  <div className="flex items-center gap-3">
                    <img src={Staywithyou} alt="Cab Icon" className="w-10 h-10" />
                    <div>
                      <h5 className="font-semibold text-sm text-[#003334]">Cab stays with you</h5>
                      <p className="text-xs text-[#003334]">
                        Take all the time you need, our driver will wait!
                      </p>
                    </div>
                  </div>
                  {/* Feature 3 - Multiple Stops */}
                  <div className="flex items-center gap-3">
                    <img src={MultipleStop} alt="Stops Icon" className="w-10 h-10" />
                    <div>
                      <h5 className="font-semibold text-sm text-[#003334">Multiple stops</h5>
                      <p className="text-xs text-[#003334]">
                        One ride for any number of pick-ups and drops
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="bg-[#58595B] rounded-2xl xl:px-6 xl:py-6 lg:px-10 lg:py-10 flex items-center justify-center text-white cursor-pointer"
              onClick={() => setDisplays(true)}
            >
              <button className="flex items-center gap-2 text-white xl:text-lg lg:text-xl font-bold uppercase">
                FILTERS
                <img src={FilterIcon} alt="Filter Icon" className="xl:w-6 xl:h-6 lg:w-8 lg:h-8" />
              </button>
            </div>

          </div>
        </div>
        <div className="w-full lg:hidden block md:block">
          <Toaster />
          <div className="bg-[#F9F4EF] rounded-3xl w-full flex flex-col ">
            <div className="p-4">
              <div className="grid grid-cols-1 gap-4 w-full">
                <div className="relative">
                  {/* Dropdown Button */}
                  <div
                    className="relative flex items-center gap-3 bg-[#ED1C24] rounded-full px-4 py-2 cursor-pointer"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    {/* Selected Option Image */}
                    {tripType && (
                      <img src={tripType.imageUrl} alt={tripType.typeName} className="w-6 h-6" />
                    )}

                    {/* Selected Option Text */}
                    <span className="text-white">{tripType?.typeName || "Select Trip Type"}</span>

                    {/* Dropdown Arrow */}
                    <img src={downArrow} alt="Dropdown Arrow" className="w-4 h-4 ml-auto" />
                  </div>
                  {/* Dropdown List */}
                  {isDropdownOpen && (
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-[90%]  bg-white border border-gray-300 rounded-b-3xl shadow-lg z-10">
                      {tripTypeData.map((option: any) => (
                        <div
                          key={option.id}
                          className="flex items-center gap-3 px-4 py-2 cursor-not-allowed bg-[#58595B] rounded-3xl m-1 text-white font-medium"
                        /**  onClick={() => {
                          if (!option.disabled) {
                            FilterParking(option);
                            setIsDropdownOpen(false);
                          }
                        }} */
                        >
                          {/* Option Image */}
                          <img src={option.imageUrl} alt={option.typeName} className="w-6 h-6" />

                          {/* Option Text */}
                          <span>{option.typeName}</span>
                        </div>
                      ))}
                      {/* Close Dropdown Arrow */}
                      <div
                        className="flex justify-center items-center py-2 cursor-pointer"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        <img src={ArrowImage} alt="Close Dropdown" className="w-5 h-5 rotate-180" />
                      </div>
                    </div>
                  )}
                </div>
                {/* Pickup Location */}
                <div className="flex flex-col">
                  {/* Dynamic Label */}
                  <label className="text-xs font-semibold text-[#58595B] mb-1">
                    {tripType?.typeName === "Airport Drop" ? <p>Pickup Address</p> : <p>From City</p>}
                  </label>
                  {/* Autocomplete Input */}
                  {isMobile && (
                    <Autocomplete onLoad={onLoadFromCity} onPlaceChanged={onPlaceChangedFromCity}>
                      <div className="flex items-center bg-[#E2E2E2] px-4 py-3 rounded-full gap-2">
                        <img src={Location} alt="Location" className="w-4 h-4" />
                        <input
                          type="text"
                          onChange={(e) => setInputFromAddress(e.target.value)}
                          ref={placesSearchRefFrom}
                          placeholder="Search Place"
                          value={inputFromAddress?.formatted_address}
                          className="w-full bg-transparent text-[#58595B] text-sm placeholder-[#58595B] focus:outline-none"
                        />
                        <img src={clearIcon} onClick={() => clearSearchResults('from')} className="cursor-pointer w-3 h-3" />

                      </div>
                    </Autocomplete>
                  )}
                  {/* Error Messages */}
                  {errors.includes("From City is required.") ? (
                    <div className="text-red-500 md:text-sm text-xs" >From City is required.</div>
                  ) : errors.find((error) => error === `We are unavailable in ${inputFromAddress}.`) ? (
                    <div className="text-red-500 md:text-sm text-xs">
                      {errors.find((error) => error === `We are unavailable in ${inputFromAddress}.`)}
                    </div>
                  ) : null}
                </div>
                {/* Pickup Date & Time */}
                <div className="flex flex-col">
                  <label className="text-xs font-semibold text-[#58595B] mb-1">PICK-UP DATE & TIME</label>
                  <div className="flex items-center bg-[#E2E2E2] px-4 py-3 rounded-full gap-2">
                    <img src={Calender} alt="Location" className="w-4 h-4" />
                    <DatePicker
                      selected={startDate}
                      minDate={new Date()}
                      showTimeSelect
                      timeIntervals={60}
                      dateFormat="dd/MM/yyyy | h:mm aa"
                      placeholderText="DD/MM/YYYY | HH:MM AM/PM"
                      onChange={(date) => setStartDate(date)}
                      className="w-full bg-transparent text-[#58595B] text-sm focus:outline-none"
                    />
                  </div>
                  {errors.includes("Checkin date is required.") && (
                    <div className="text-red-500 md:text-sm text-xs" >Checkin date is required.</div>
                  )}
                </div>
                {/* Dropoff Location */}
                <div className="border-t-2 border-dashed border-red-500 w-full"></div>
                {tripType?.typeName !== "Hourly Rental" && (
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold text-[#58595B] mb-1">
                      {tripType?.typeName === "Airport Drop" ? <p>Drop Airport</p> : <p>To City</p>}
                    </label>
                    {isMobile && (
                      <Autocomplete onLoad={onLoadToCity} onPlaceChanged={onPlaceChangedToCity} options={{
                        types: tripType?.typeName === "Airport Drop" ? ["airport"] : [],
                      }} className="w-full">
                        <div className="flex items-center bg-[#E2E2E2] px-4 py-3 rounded-full gap-2">
                          <img src={Location} alt="Location" className="w-4 h-4" />
                          <input
                            type="text"
                            onChange={(e) => setInputToAddress(e.target.value)}
                            ref={placesSearchRefTo}
                            placeholder="Search Place"
                            value={inputToAddress?.formatted_address}
                            className="w-full bg-transparent text-[#58595B] text-sm placeholder-[#58595B] focus:outline-none"
                          />
                          <img src={clearIcon} onClick={() => clearSearchResults('to')} className="cursor-pointer w-3 h-3" />
                        </div>
                      </Autocomplete>
                    )}
                    {/* Error Message */}
                    {errors.includes("To City is required.") && (
                      <div className="text-red-500 md:text-sm text-xs">To City is required.</div>
                    )}
                  </div>)}

                {/* Dropoff Date & Time (Only for Outstation Round Trip) */}
                {tripType?.typeName === "OutStation Round Trip" && (
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold text-[#58595B] mb-1">{tripType?.typeName === "OutStation Round Trip" ? <p>RETURN DATE & TIME</p> : <p>DROP-OFF DATE & TIME</p>}</label>
                    <div className="flex items-center bg-[#E2E2E2] px-4 py-3 rounded-full gap-2">
                      <img src={Calender} alt="Location" className="w-4 h-4" />
                      <DatePicker
                        selected={endDate}
                        showTimeSelect
                        timeIntervals={60}
                        dateFormat="dd/MM/yyyy | h:mm aa"
                        placeholderText="DD/MM/YYYY | HH:MM AM/PM"
                        onChange={(date) => setEndDate(date)}
                        className="w-full bg-transparent text-[#58595B] text-sm focus:outline-none"
                      />
                    </div>
                    {errors.includes("Checkout date is required.") && (
                      <div className="text-red-500 md:text-sm text-xs" >Checkout date is required.</div>
                    )}
                  </div>
                )}
                {/* Package Type (Only for Hourly Rental) */}
                {tripType?.typeName === "Hourly Rental" && (
                  <div className="flex-1 relative">
                    {/* Label */}
                    <span className="text-xs font-semibold text-[#58595B] mb-1 block">Package Type</span>
                    {/* Dropdown Button */}
                    <div
                      className="relative flex items-center gap-3 bg-[#E2E2E2] rounded-full px-4 py-3 cursor-pointer"
                      onClick={() => setIsPackageTypeDropdownOpen(!isPackageTypeDropdownOpen)}
                    >
                      {/* Selected Option Text */}
                      <span className="text-[#58595B] text-sm">
                        {selectedPackage || "Select Package"}
                      </span>
                      {/* Dropdown Arrow */}
                      <img src={ArrowImage} alt="Dropdown Arrow" className="w-4 h-4 ml-auto" />
                    </div>
                    {/* Dropdown List */}
                    {isPackageTypeDropdownOpen && (
                      <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-[90%]  bg-white border border-gray-300 rounded-b-3xl shadow-lg z-10">
                        {packageType.map((option: any, index: any) => (
                          <div
                            key={index}
                            className="flex items-center gap-3 mx-3 px-4 py-2 cursor-pointer mt-2 bg-[#58595B] rounded-3xl text-white font-medium hover:bg-[#ED1C24]"
                            onClick={() => {
                              setSelectedPackage(option.displayValue); // Fix: Set selected package
                              setIsPackageTypeDropdownOpen(false); // Fix: Close dropdown after selection
                            }}
                          >
                            {/* Option Text */}
                            <span>{option.displayValue}</span>
                          </div>
                        ))}

                        {/* Close Dropdown Arrow */}
                        <div
                          className="flex justify-center items-center py-2 cursor-pointer"
                          onClick={() => setIsPackageTypeDropdownOpen(false)} // Fix: Close the dropdown
                        >
                          <img src={ArrowImage} alt="Close Dropdown" className="w-5 h-5 rotate-180" />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {/* Search Engine Button */}
              <div className="flex items-center justify-center mt-6">
                <div className="relative w-[120px] h-[120px] flex items-center justify-center rounded-full border-[6px] border-[#ED1C24]">
                  {/* Middle Circle (White Border) */}
                  <div className="w-[110px] h-[110px] flex items-center justify-center rounded-full border-[6px] border-white">
                    {/* Inner Circle (Button) */}
                    <button
                      type="submit"
                      onClick={handleSearchClick}
                      className="w-[100px] h-[100px] flex flex-col items-center justify-center rounded-full bg-[#ED1C24] text-white font-semibold text-lg transition-all hover:bg-[#ED1C24]"
                    >
                      <span className="text-md lg:text-lg tracking-widest">ENGINE</span>
                      <span style={{ fontWeight: "bold" }} className="text-md lg:text-lg tracking-widest">START</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center mt-5  bg-[#D3F4F3] p-3 rounded-3xl gap-6">
            {/* Heading */}
            <h4 className="md:text-lg text-sm text-[#003334] font-semibold text-center ">
              Why Book with us?
            </h4>
            {/* Features Section */}
            <div className="flex flex-col md:flex-row gap-6 w-full justify-center md:justify-start">
              {/* Feature 1 - Convenient Sightseeing */}
              <div className="flex flex-col md:flex-row items-center gap-3 text-center md:text-left">
                <img src={SightSeeing} alt="Sightseeing Icon" className="w-12 h-12" />
                <div>
                  <h5 className="font-semibold md:text-sm text-xs text-[#003334]">
                    Convenient sightseeing
                  </h5>
                  <p className="md:text-xs text-[10px] text-[#003334]">
                    Comfortable cabs for great vacation experiences
                  </p>
                </div>
              </div>

              {/* Feature 2 - Cab Stays With You */}
              <div className="flex flex-col md:flex-row items-center gap-3 text-center md:text-left">
                <img src={Staywithyou} alt="Cab Icon" className="w-12 h-12" />
                <div>
                  <h5 className="font-semibold md:text-sm text-xs text-[#003334]">
                    Cab stays with you
                  </h5>
                  <p className="md:text-xs text-[10px] text-[#003334]">
                    Take all the time you need, our driver will wait!
                  </p>
                </div>
              </div>

              {/* Feature 3 - Multiple Stops */}
              <div className="flex flex-col md:flex-row items-center gap-3 text-center md:text-left">
                <img src={MultipleStop} alt="Stops Icon" className="w-12 h-12" />
                <div>
                  <h5 className="font-semibold md:text-sm text-xs text-[#003334]">
                    Multiple stops
                  </h5>
                  <p className="md:text-xs text-[10px] text-[#003334]">
                    One ride for any number of pick-ups and drops
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className=" flex flex-row items-center justify-center">
            <div
              className="bg-[#58595B] w-[30%] mt-4 rounded-lg  px-4 py-2 flex items-center justify-center text-white cursor-pointer"
              onClick={() => setDisplays(true)}
            >
              <button className="flex items-center gap-1 text-white text-sm font-bold uppercase">
                FILTERS
                <img src={FilterIcon} alt="Filter Icon" className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
        <div className="flex justify-center h-full w-full">
          <div
          >
            {isAlertVisible && (
              <div className="w-full justify-center ">
                <MuiAlert
                  severity={statusCode?.type!}
                  messageType={statusCode?.code!}
                />
              </div>
            )}
            <div className="justify-center mt-6">
              {parkingSpaces && parkingSpaces?.length > 0 ? (
                parkingSpaces.map((parking: any, index: number) => {
                  return (
                    <ParkingComponent
                      key={index}
                      type={parking?.parkingTypeResDTO?.typeName}
                      data={parking}
                      toggleFavourites={toggleFavourites}
                      checkIn={startDate}
                      checkOut={
                        tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
                          ? null
                          : tripType.typeName === "OutStation Round Trip"
                            ? endDate
                            : tripType.typeName === "Hourly Rental" && startDate
                              ? moment(startDate)
                                .add(
                                  parseInt(
                                    (
                                      typeof selectedPackage === "string"
                                        ? selectedPackage.match(/^(\d+)\s*hrs/)?.[1]
                                        : typeof tripData.packageType === "string"
                                          ? tripData.packageType.match(/^(\d+)\s*hrs/)?.[1]
                                          : "2"
                                    ) || "2",
                                    10
                                  ),
                                  "hours"
                                )
                                .toDate()
                              : tripData.checkOut
                      }
                      selectedTZOptions={selectedTZOptions}
                      userLat={fromcoords?.lat}
                      userLng={fromcoords?.lng}
                      parkingLat={parking.latitude}
                      parkingLng={parking.longitude}
                      locationData={locationData}
                      index={index}
                      tripType={tripType}
                      packageType={selectedPackage || tripData.packageType}
                      duration={(tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null}
                      distance={(tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null}
                    />
                  );

                })
              ) : (
                <div className="text-center mb-10 text-red-500 pt-2 md:flex h-[70%] w-full items-center justify-center">
                  <h4 className="font-bold text-red-500 p-4 mt-4">
                    {allResponse.isLoading
                      ? "Please wait... Loading"
                      : parkingSpaces?.length === 0 &&
                      "No Vehicle's available !!!"}
                  </h4>
                </div>
              )}
            </div>
          </div>
          <div></div>
          {isToggel === true ? (
            <div className="md:w-[50%] w-[648px] hidden md:flex">
              {fromcoords && (
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: googleApiKey,
                  }}
                  defaultCenter={fromcoords}
                  center={fromcoords}
                  defaultZoom={13}
                  onChange={(changedCoords) => {
                    setFromCoords({
                      lat: changedCoords.center.lat,
                      lng: changedCoords.center.lng,
                    });
                  }}
                >
                  <LocationPin
                    lat={currentLocation?.lat}
                    lng={currentLocation?.lng}
                  />
                  {parkingSpaces &&
                    parkingSpaces.map((parking: any, index: number) => (
                      <SpottedParkings
                        key={index}
                        lat={parking?.latitude}
                        lng={parking?.longitude}
                        data={parking}
                      />
                    ))}
                </GoogleMapReact>
              )}
            </div>
          ) : null}

          <Modal open={displays} onClose={() => setDisplays(false)}>
            <div
              className="bg-white rounded-2xl shadow-lg p-6 md:w-[60%] w-[80%] lg:w-[30%] 
               fixed right-0 lg:top-[60%] md:top-[70%] top-[50%] transform -translate-y-1/2 mr-5"
            >
              <button className="absolute top-3 right-3" onClick={() => setDisplays(false)}>
                <img src={clearIcon} className="cursor-pointer w-5 h-5" />
              </button>
              {/* Filters Component */}
              <Filters
                displays={displays}
                handleFilter={handleFilter}
                setDisplays={setDisplays}
                coords={fromcoords}
                favorateData={favorateData}
                selectedPackage={selectedPackage}
              />
            </div>
          </Modal>
        </div>
        {allResponse.isLoading || favouriteResponse.isLoading ? (
          <Loading />
        ) : null}
      </div>
      <div />
      {/* <div className="mt-5 lg:top-auto">
        <Footer />
      </div> */}
    </div>
  );
};

export default FindParkingSlot;
